// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { Flex, Image } from 'antd';
import LoadingSpinner from '../loading/Loading';
import './Photo.less';
export interface PhotoProps {
  image?: string;
}
const Photo = (props: PhotoProps) => {
  return (
    <Flex align="center" vertical className="photo-flex-container">
      {props.image ? <Image width="100%" src={`${props.image}`} /> : <LoadingSpinner />}
    </Flex>
  );
};
export default Photo;
